<template>
  <nav class="navBarList">
    <v-app-bar app color="primary" dark style="box-shadow: none">
      <!-- <v-toolbar-title>{{ $t("navbar.title") }}</v-toolbar-title> -->
      <ul class="px-10 hiddenElemen ">
        <li>
          <v-menu bottom origin="center center" transition="scale-transition"  >
            <template v-slot:activator="{ on, attrs }">
              <v-list-item v-bind="attrs" v-on="on" >
                <v-list-item-icon class="mx-1">
                  <span class="">
                    <i  class="fas fa-globe"></i>
                  </span>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ $t("sidebar.lang") }}
                    <span class="mx-2"><i  class="fas fa-angle-down"></i></span
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-list class="navLang" style="background-color: #42160e !important;">
              <v-list-item two-line @click="changeLang('ar')" >
                <v-checkbox
                  v-model="selectedLand"
                  label="العربية"
                  color="white"
                  class="white--text"
                  hide-details
                  :readonly="true"
                  value="ar"
                ></v-checkbox>
              </v-list-item>

              <v-list-item two-line @click="changeLang('en')">
                <v-checkbox
                  v-model="selectedLand"
                  label="English"
                  color="white"
                  hide-details
                  class="white--text"
                  :readonly="true"
                  value="en"
                ></v-checkbox>
              </v-list-item>

              <v-list-item two-line @click="changeLang('fa')">
                <v-checkbox
                  v-model="selectedLand"
                  label="فارسي"
                  color="white"
                  hide-details
                  class="white--text"
                  :readonly="true"
                  value="fa"
                ></v-checkbox>
              </v-list-item>
            </v-list>
          </v-menu>
        </li>
      </ul>
      <ul class="px-10 hiddenElement navbarUl">
        <li>
          <v-btn
            to="/"
            color="primary rounded-0"
            style="height: 55px"
            elevation="0"
            class="white--text"
          >
            {{ $t("sidebar.home") }}
          </v-btn>
        </li>
        <span v-if="loggedIn">|</span>
        <li  v-if="loggedIn">
          <v-btn
             to="/mybooks"
            color="primary rounded-0"
            style="height: 55px"
            elevation="0"
            class="white--text"
          >
            {{ $t("sidebar.mybook") }}
          </v-btn>
        </li>
        |
        <li>
          <v-btn
            to="/contactus"
            color="primary rounded-0"
            style="height: 55px"
            elevation="0"
            class="white--text"
          >
            {{ $t("sidebar.contactUs") }}
          </v-btn>
        </li>
        |
        <li>
          <v-btn
            to="/about-us"
            color="primary rounded-0"
            style="height: 55px"
            elevation="0"
            class="white--text"
          >
            {{ $t("sidebar.about-us") }}
          </v-btn>
        </li>
      </ul>

      <v-spacer></v-spacer>
      <ul  v-if="!loggedIn" class="px-9 hiddenElement " >
        <li>
          <v-btn
            to="/login?register=false"
            color="warning "
            class="font-weight-bold rounded-lg primary--text mx-1"
          >
            {{ $t("sidebar.login") }}
          </v-btn>
        </li>
        <li>
          <v-btn  to="/login?register=true" outlined color="white" class="rounded-lg mx-1">
            {{ $t("sidebar.singup") }}
          </v-btn>
        </li>
      </ul>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" :right="!right" app>
      <v-list class="pt-0">
        <v-list-item two-line v-if="loggedIn">
          <v-list-item-avatar width="50" height="50" >
            <v-icon x-large color="white" class="userNameIcon">mdi-account</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ getName }}  </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item-group v-model="model">
          <router-link
            v-if="!loggedIn"
            to="/login"
            class="text-decoration-none"
          >
            <v-list-item>
              <v-list-item-icon>
                <span class="iconsSidbar">
                  <i class="fa fa-key"></i>
                </span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  $t("sidebar.login-register")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/" class="text-decoration-none">
            <v-list-item>
              <v-list-item-icon>
                <span class="iconsSidbar">
                  <i  class="fas fa-home"></i>
                </span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("sidebar.home") }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

           

          <!-- <v-list>
            <v-list-group>
              <template v-slot:activator>
                  <v-list-item-icon>
                    <span class="iconsSidbar">
                      <i class="fab fa-windows"></i>
                    </span>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>System</v-list-item-title>
                  </v-list-item-content>
              </template>


              <router-link to="/language" class="text-decoration-none">
                <v-list-item>
                  <v-list-item-icon>
                    <span class="iconsSidbar ml-6">
                      <i  class="fas fa-globe"></i>
                    </span>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Language</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>

            </v-list-group>
          </v-list> -->

          <router-link
            v-if="loggedIn"
            to="/mybooks"
            class="text-decoration-none"
          >
            <v-list-item>
              <v-list-item-icon>
                <span class="iconsSidbar">
                  <i  class="fas fa-swatchbook"></i>
                </span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  $t("sidebar.mybook")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/contactus" class="text-decoration-none">
            <v-list-item>
              <v-list-item-icon>
                <span class="iconsSidbar">
                  <i class="fas fa-phone-square-alt"></i>
                </span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("sidebar.contactUs") }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/about-us" class="text-decoration-none">
            <v-list-item>
              <v-list-item-icon>
                <span class="iconsSidbar">
                  <i class="fas fa-info-circle"></i>
                </span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("sidebar.about-us") }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <v-menu bottom origin="center center" transition="scale-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-list-item v-bind="attrs" v-on="on">
                <v-list-item-icon class="mx-1">
                  <span class="iconsSidbar">
                    <i  class="fas fa-globe"></i>
                  </span>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ $t("sidebar.lang") }}
                    <span class="mx-2"><i  class="fas fa-angle-down"></i></span
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-list class="navLang">
              <v-list-item two-line @click="changeLang('ar')">
                <v-list-item-subtitle>العربية</v-list-item-subtitle>
              </v-list-item>

              <v-list-item two-line @click="changeLang('en')">
                <v-list-item-subtitle>English</v-list-item-subtitle>
              </v-list-item>

              <v-list-item two-line @click="changeLang('fa')">
                <v-list-item-subtitle>فارسي</v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-menu>

          <router-link
            v-if="loggedIn"
            to="/logout"
            class="text-decoration-none"
          >
            <v-list-item @click="drawer = !drawer">
              <v-list-item-icon>
                <span class="iconsSidbar">
                  <i  class="fas fa-sign-out-alt"></i>
                </span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  $t("sidebar.logout")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list-item-group>


      </v-list>
      <Footer /> 
    </v-navigation-drawer>
    
  </nav>
</template>
<style>
  .navLang .v-input--selection-controls__input .v-icon{
    color: #fff  !important;
  }
</style>

<style scoped>
.v-navigation-drawer{
      max-height: 100% !important
}
.userNameIcon{
  border: 1px solid orange;
  background: orange;
}
.iconsSidbar {
  color: #8bc34a;
  font-size: 20px;
}
.white--text /deep/ label {
    color: #fff;
}

.theme--light.v-list-item .v-ripple__container{
  display: none !important
}
.theme--light.v-input {
  margin: 0;
}

.navBarList ul {
  list-style: none;
}
.navBarList ul li {
  display: inline-block;
}

.v-list-item--two-line {
  min-height: 40px;
}
.v-sheet.v-list {
  background: #fff;
}
.theme--light.v-list-item .v-list-item__subtitle {
  color: #fff;
}
.v-input--selection-controls .v-input__slot > .v-label{
  color: #fff !important;
}


/* @media (min-width: 768px) {
  .v-toolbar__content .v-btn.v-btn--icon.v-size--default, .v-toolbar__extension .v-btn.v-btn--icon.v-size--default {
    display: none;
  }
} */

/* @media (min-width: 768px) {
  .v-application--is-rtl .v-toolbar__content > .v-btn.v-btn--icon:last-child,
  .v-application--is-rtl .v-toolbar__extension > .v-btn.v-btn--icon:last-child,
  .v-application--is-ltr .v-toolbar__content > .v-btn.v-btn--icon:last-child,
  .v-application--is-ltr .v-toolbar__extension > .v-btn.v-btn--icon:last-child {
    display: none;
  }
} */
@media (max-width: 1024px) {
  .navBarList .px-10 {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
}
@media (max-width: 872px) {
  .navBarList .px-10 {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
  .navBarList .v-btn {
    padding: 0px 2px !important;
  }
  .navBarList .v-btn__content {
    font-size: 5px !important;
  }
}

@media (max-width: 768px) {
  .v-application--is-rtl .v-toolbar__content > .v-btn.v-btn--icon:last-child,
  .v-application--is-rtl .v-toolbar__extension > .v-btn.v-btn--icon:last-child,
  .v-application--is-ltr .v-toolbar__content > .v-btn.v-btn--icon:last-child,
  .v-application--is-ltr .v-toolbar__extension > .v-btn.v-btn--icon:last-child {
    display: none;
  }
  .navBarList .px-10 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .navbarUl li button {
    background: red !important;
    padding: 0 !important;
  }

  /* .navbarUl li button{
    font-size: 12px;
    padding: 0 o !important
  } */
}

@media (max-width: 768px) {
  .v-application--is-rtl .v-toolbar__content > .v-btn.v-btn--icon:last-child,
  .v-application--is-rtl .v-toolbar__extension > .v-btn.v-btn--icon:last-child {
    display: block;
  }
  .hiddenElement {
    display: none !important;
  }
}

/* @media (min-width: 769px) {
  .v-application--is-rtl .v-toolbar__content > .v-btn.v-btn--icon:last-child, 
  .v-application--is-rtl .v-toolbar__extension > .v-btn.v-btn--icon:last-child{
    display: none;
  }
} */

/* hiddenElement */
</style>
<script>
import Footer from "@/components/Footer";

export default {
  data: () => ({
    selectedLand : 'ar' ,
    drawer: false,
    model: 0,
    right: true,
  }),
  created() {
    this.changeLang();
  },
  components: { Footer},
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    getName() {
      return this.$store.getters.getName;
    },
  },
  methods: {
    changeLang(events = localStorage.getItem("lang") || "ar") {
      if (events == "en") {
        this.right = false;
        this.$vuetify.rtl = false;
      } else {
        this.right = true;
        this.$vuetify.rtl = true;
      }
      localStorage.setItem("lang", events);
      this.selectedLand = events
      this.$root.$i18n.locale = events;
      this.$store.commit("SetLang");
    },
  },
};
</script>
